import { render } from "./InstructionView.vue?vue&type=template&id=334e610c&ts=true"
import script from "./InstructionView.vue?vue&type=script&lang=ts"
export * from "./InstructionView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__